<template>
  <div class="animated fadeIn">
    <h3 class="header-title">Learning EPay</h3>
    <label>Let’s see your tuition EPay.</label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your ePay !</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <!-- <CRow>
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </CRow> -->
    <template>
      <template>
        <div>
          <CCard class="mt-4">
            <CRow class="m-0">
              <CCol sm="12">
                <CDataTable
                  :hover="hover"
                  :striped="striped"
                  :bordered="bordered"
                  :small="small"
                  :fixed="fixed"
                  :items="Remainings"
                  :fields="fields"
                  items-per-page-select
                  :items-per-page="small ? 5 : 10"
                  :dark="dark"
                  columnFilter
                  pagination
                >
                </CDataTable>
              </CCol>
            </CRow>
            <CRow> </CRow>
          </CCard>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
Vue.use(VuejsDialog);

export default {
  name: "EPayTotal",
  components: {
    cSwitch,
    PulseLoader,
  },
  data: function () {
    return {
      collapse: false,
      Remainings: [],
      fields: [
        { key: "Name" },
        { key: "UserId" },
        { key: "Credit" },
        { key: "Debit" },
        { key: "Total" },
        { key: "LastCredit" },
        { key: "TransactionDate" },
      ],
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      await this.GetRemainingTransaction();
    }
    else {
      this.GoToLogin();
    }
  },
  computed: {
    // TotalDebit() {
    //   return this.Transactions.reduce((totalDebit, item) => {
    //     return totalDebit + item.Debit;
    //   }, 0);
    // },
    // TotalCredit() {
    //   return this.Transactions.reduce((totalCredit, item) => {
    //     return totalCredit + item.Credit;
    //   }, 0);
    // },
    // TotalCredit: {
    //   get: function () {
    //     return _.reduce(
    //       this.FilterTransaction,
    //       function (memo, item) {
    //         return memo + item.Credit;
    //       },
    //       0
    //     );
    //   },
    // },
    // TotalDebit: {
    //   get: function () {
    //     return _.reduce(
    //       this.FilterTransaction,
    //       function (memo, item) {
    //         return memo + item.Debit;
    //       },
    //       0
    //     );
    //   },
    // },
  },
  methods: {
    async GetRemainingTransaction() {
      return this.$API
       .get(this.$RemainingTransaction, {
          withCredentials: true,
        })
        .then(
          function (response) {
            this.Remainings = response.data;

          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
  },
};
</script>

<style>
.checkbox-form {
  display: flex;
  flex-direction: column;
  align-items: self-start;
  font-size: 16px;
}
.custom-text-overview {
    color: #000000 !important; 
}
.custom-small-overview {
    font-size: 90%;
    font-weight: 500;
} 
.custom-small {
    font-size: 90%;
    font-weight: 500;
}
.custom-btn-blues{
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
  width: 155px;
}
</style>